import { Grid, List, ListItem, Typography } from "@mui/material";

import Chip from "../../../../common/Chip/Chips";
import Time from "../../../../common/Time/Time";

import IMAGES from "../../../../../assets/themes/images/images";
import styles from "../../styles.module.scss";

type Props = {
  modalFooterHeight: number;
  patient: any;
};

const AdmissionHistoryLogs = (props: Props) => {
  const { modalFooterHeight, patient } = props;
  return (
    <Grid item xs={12} lg={7}>
      <div
        className={styles.modalRightPanel}
        style={{ marginTop: modalFooterHeight }}
      >
        <Typography
          className={`${styles.activityHeading} mg-b-15`}
          variant="h6"
          component="h2"
        >
          Activity
        </Typography>
        <List sx={{ padding: 0 }}>
          {patient?.logs?.map((l: any) => {
            return (
              <ListItem
                key={l._id}
                className={styles.activityList}
                sx={{ padding: 0 }}
              >
                <div className={`avatar avatar-circle ${styles.profile}`}>
                  <img src={IMAGES.Profile} alt="profile" />
                </div>
                <div>
                  <div className="font-size-14">
                    <strong className="font-weight-medium">
                      {l?.updatedBy?.name}
                    </strong>{" "}
                    changed status{" "}
                    {l?.fromStatus && `from ` && <Chip label={l?.fromStatus} />}{" "}
                    to <Chip label={l?.toStatus} />.
                  </div>

                  {l?.remark && (
                    <>
                      •
                      <span className="font-size-14 text-info">
                        Remark: {l?.remark}
                      </span>
                    </>
                  )}
                  <br />
                  <span className="font-size-14 text-secondary">
                    <Time time={l.time} />
                  </span>
                </div>
              </ListItem>
            );
          })}
        </List>
      </div>
    </Grid>
  );
};

export default AdmissionHistoryLogs;
